module.exports = __webpack_public_path__ + "prod/1.42.2/img/cpys_four.c98e97ba.png";